import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
    getTokenFromLocalStorage,
    isTokenExpired,
    sessionExpired,
} from '../utilities/tokenUtils';
import { getUserFromLocalStorage } from '../utilities/user.js';

const useAuth = (isProtected = false) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const history = useHistory();

    useEffect(() => {
        const validateAuth = async () => {
            const token = getTokenFromLocalStorage();
            if (!token || isTokenExpired(token)) {
                setIsAuthenticated(false);
                setUser(null);
                if (isProtected) {
                    // A present-but-expired token is a real session expiry and
                    // must clear the encrypted profile and refresh credential.
                    // A missing token is simply a signed-out visit.
                    if (token) sessionExpired('expired');
                    history.replace('/auth/login-page');
                }
            } else {
                const userData = getUserFromLocalStorage();
                if (userData) {
                    setUser(userData);
                    setIsAuthenticated(true);
                } else {
                    setIsAuthenticated(false);
                    if (isProtected) {
                        history.replace('/auth/login-page');
                    }
                }
            }
            setLoading(false);
        };

        validateAuth();
    }, [isProtected]);

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('profile');
        localStorage.removeItem('refreshToken');
        setUser(null);
        setIsAuthenticated(false);
        history.replace('/auth/login-page');
    };

    return { user, loading, isAuthenticated, logout };
};

export default useAuth;
